import { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { toast } from 'react-toastify'
import api from '../../../services/api'
import { errorApi } from '../../../utils/errorApi'
import { WhatsappLogo } from 'phosphor-react'

import { openWindow } from '../../../utils/whatsapp'

import styles from './styles.module.css'
import { useLoading } from '../../../hooks/LoadingContext'

function DriverInfo({ driverId, setVehicleId }) {
  const [driverInfo, setDriverInfo] = useState({})

  const { setIsLoading } = useLoading()

  const getDateInterval = (actualDate, pastDate) => {
    const timeDiff = Math.abs(actualDate - pastDate)
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

    const years = Math.floor(diffDays / 365)
    const months = Math.floor((diffDays % 365) / 30)
    return `${years} ${years > 1 ? 'anos' : 'ano'} e ${months} ${months > 1 ? 'meses' : 'mês'}`
  }

  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true)
        const { data } = await api.get(`/company/drivers/${driverId}?vehicleData=true`)
        data.timeInCompany = getDateInterval(new Date(), new Date(data.created_at))

        setDriverInfo(data)
        if (data.vehicle) setVehicleId(data.vehicle.id)
      } catch (err) {
        toast.error(
          errorApi(
            err,
            'Falha ao buscar as estatísticas do motorista. Tente novamente mais tarde.',
          ),
        )
      }
      setIsLoading(false)
    }
    loadData()
  }, [driverId, setVehicleId, setIsLoading])

  return (
    <div className={`${styles.infosContainer} border`}>
      <div style={{ marginLeft: 16, marginTop: 16 }}>
        <span className={styles.nameHeader}>{driverInfo.name}</span>
        <span className={styles.modelColor}>
          {driverInfo.vehicle
            ? `${driverInfo.vehicle.model} ${driverInfo.vehicle.color} (${driverInfo.vehicle.board})`
            : 'Último veículo desconhecido'}
        </span>
        <span
          className={styles.infoSpan}
          style={{
            marginTop: 13,
          }}
        >
          Cidade:{' '}
          <span
            style={{
              fontWeight: '400',
              fontSize: 15,
            }}
          >
            {`${driverInfo.city} - ${driverInfo.state}`}
          </span>
        </span>
        <span className={styles.infoSpan}>
          Tempo de empresa:{' '}
          <span
            style={{
              fontWeight: '400',
              fontSize: 15,
            }}
          >
            {driverInfo.timeInCompany}
          </span>
        </span>
        <span className={styles.infoSpan}>
          Contato:{' '}
          <span
            style={{
              fontWeight: '400',
              fontSize: 15,
            }}
          >
            {driverInfo.phone ? driverInfo.phone : 'Desconhecido'}
          </span>
        </span>
      </div>
      <div className="text-center mt-2 mb-3">
        <Button
          className={styles.contactDriverBtn}
          disabled={!driverInfo.phone}
          onClick={() => openWindow(driverInfo.phone)}
        >
          <WhatsappLogo style={{ marginRight: 3, marginTop: -3 }} size={20}></WhatsappLogo>
          Entrar em contato com o motorista
        </Button>
      </div>
    </div>
  )
}

export default DriverInfo
